"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgVk = function SvgVk(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 8,
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.689 20.215s.113-1.176 1.653-1.214c1.54-.037 4.408 0 4.408 0s1.906.098 1.906 1.56v5.516s-.024 1.493.712 1.655c.737.161 1.907-1.46 2.48-2.398.575-.937 2.412-4.44 2.412-4.44s.282-1.158 1.076-1.158h5.204s2.054.031 1.219 1.72c-.835 1.69-4.279 6.276-4.279 6.276s-1.342 1.641 0 2.813c1.343 1.172 3.149 3.128 3.576 3.702.427.574 1.656 2.74 0 2.74h-5.41s-1.641-.226-2.72-1.502c-1.077-1.277-2.008-2.669-2.964-2.689-.957-.02-1.306 2.689-1.306 2.689s.007 1.502-1.191 1.502-4.696.41-7.527-1.763c-2.831-2.172-3.45-3.125-4.913-5.309-1.462-2.183-4.561-8.15-4.561-8.15s-1.125-2.029.478-2.029h4.083s1.24-.186 1.945 1.466c.704 1.651 1.803 3.808 2.968 5.17 1.165 1.36 1.9 2.335 2.404.502.29-2.544.29-3.585.29-3.585s-.174-2.06-.697-2.394c-.524-.333-1.246-.68-1.246-.68Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgVk);
var _default = exports["default"] = Memo;